import { batch, Component, createSignal, untrack } from 'solid-js';
import { Portal } from 'solid-js/web';
import { t } from '@trimble/i18n';
import { useLayerPopup } from '../utils/layer-popup-utils';
import { readModusInputChangeValue } from '@trimble/utilities';
import { LayerRenamePopupProps } from './LayerRenamePopup.types';

export const LayerRenamePopup: Component<LayerRenamePopupProps> = (props) => {
  let popupRef: HTMLDivElement | undefined;
  const [itemName, setItemName] = createSignal<string>(
    untrack(() => props.name)
  );

  const handleClose = (): void => {
    triggerSave();
    props.onClose();
  };

  const triggerSave = (): void => {
    const trimmed = itemName().trim();
    if (trimmed !== props.name.trim() && trimmed.length > 0) {
      props.onNameChange(itemName());
    }
  };

  useLayerPopup({
    popupRef: () => popupRef,
    anchorElement: () => props.anchorElement,
    onClose: () => handleClose,
    offsetY: 0,
  });

  return (
    <Portal>
      <div
        data-testid="layer-rename-popup"
        ref={(el) => {
          popupRef = el;
        }}
        class="fixed z-dropdown-elevated bg-white shadow-lg rounded-md border border-gray-2 p-3 w-[285px]"
      >
        <div class="flex flex-col gap-1">
          <label class="text-xs text-gray-6">
            {t('shared.data-prep.pdf-page-name-label')}
          </label>
          <div
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                batch(() => {
                  triggerSave();
                  props.onClose();
                });
              }
            }}
          >
            <modus-wc-text-input
              class="w-full"
              size="md"
              label=""
              bordered={true}
              value={itemName()}
              read-only={false}
              placeholder={t('shared.data-prep.enter-pdf-page-name')}
              on:inputChange={(e) => {
                setItemName(readModusInputChangeValue(e));
              }}
            />
          </div>
        </div>
      </div>
    </Portal>
  );
};
